import { render, staticRenderFns } from "./BeneficiaireTable.vue?vue&type=template&id=3baa715a&scoped=true"
import script from "./BeneficiaireTable.vue?vue&type=script&lang=js"
export * from "./BeneficiaireTable.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaireTable.vue?vue&type=style&index=0&id=3baa715a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa715a",
  null
  
)

export default component.exports